import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    groupName,
    groupNameError,
    serverError,
    demoModeError,
    onGroupNameChange,
    onCreateClick,
    onInputClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else if (demoModeError) return 'demoModeError';
        else return '';
    }, [serverError, demoModeError]);

    return (
        <ModalComponent
            className="add-group"
            title="addGroupTitle"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="groupName"
                    helperText="groupNameHelperText"
                    name="name"
                    type="text"
                    errorMessage="wrongGroupName"
                    lang={lang}
                    value={groupName}
                    error={groupNameError}
                    onChange={onGroupNameChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="create"
                    lang={lang}
                    onClick={onCreateClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onClose}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const AddGroupComponent = React.memo(Component);

export default AddGroupComponent;
